import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'
import { isoDate } from './iso-date'
import { monthsInRange } from '../date-range.util'

const MAX_RANGE_MONTHS = 36

export const expensesByCategoryQuerySchema = z
  .object({
    from: isoDate,
    to: isoDate,
    baseCurrency: z.nativeEnum(Currency).optional(),
  })
  .refine((q) => q.from <= q.to, { message: 'from must be on or before to', path: ['from'] })
  .refine((q) => monthsInRange(q.from, q.to) <= MAX_RANGE_MONTHS, {
    message: `range must not exceed ${MAX_RANGE_MONTHS} months`,
    path: ['to'],
  })

export type ExpensesByCategoryQueryDto = z.infer<typeof expensesByCategoryQuerySchema>

export const EXPENSES_BY_CATEGORY_MAX_RANGE_MONTHS = MAX_RANGE_MONTHS
